import { Box, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";

const RevenuePrediction = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isSmallScreen = isXs || isSm || isMd;

  const data = [
    { month: "Jan", actual: 42, predicted: null },
    { month: "Feb", actual: 46, predicted: null },
    { month: "Mar", actual: 41, predicted: null },
    { month: "Apr", actual: 47, predicted: null },
    { month: "May", actual: 44, predicted: 44 },
    { month: "Jun", actual: null, predicted: 52 },
    { month: "Jul", actual: null, predicted: 58 },
    { month: "Aug", actual: null, predicted: 64 },
    { month: "Sep", actual: null, predicted: 62 },
    { month: "Oct", actual: null, predicted: 58 },
    { month: "Nov", actual: null, predicted: 68 },
    { month: "Dec", actual: null, predicted: 72 },
  ];

  const formatYAxisTick = (value) => {
    if (value === 0) return "0";
    if (value === 10) return "1K";
    if (value === 20) return "2K";
    if (value === 30) return "3K";
    if (value === 40) return "4K";
    if (value === 50) return "5K";
    if (value === 60) return "6K";
    if (value === 70) return "7K";
    if (value === 80) return "8K";
    return "";
  };

  return (
    <Box
      style={{
        margin: 0,
        padding: 0,
        // boxSizing: "border-box",
        fontFamily: "Outfit",
        // backgroundColor: "#f8f9ff",
        padding: isSmallScreen
          ? isXs
            ? "12px"
            : isSm
            ? "16px"
            : "20px"
          : "24px",
        marginLeft: isSmallScreen ? "0" : "-200%",
      }}
    >
      <Box
        style={{
          maxWidth: isSmallScreen ? "100%" : "1450px",
          marginRight: isSmallScreen ? "0" : "1.5%",
          margin: "0 auto",
          background: "white",
          borderRadius: "12px",
          padding: isSmallScreen
            ? isXs
              ? "16px"
              : isSm
              ? "20px"
              : "24px"
            : "24px 32px",
          // boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
          // border: "1px solid #f1f3f9",
        }}
      >
        {/* Header */}
        <Box
          style={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            justifyContent: isSmallScreen ? "flex-start" : "space-between",
            alignItems: isSmallScreen ? "stretch" : "flex-start",
            marginBottom: isSmallScreen ? (isXs ? "20px" : "22px") : "24px",
            gap: isSmallScreen ? "20px" : "0",
          }}
        >
          <Box>
            <h1
              style={{
                fontSize: isSmallScreen ? (isXs ? "18px" : "19px") : "20px",
                fontWeight: "600",
                color: "#1f2937",
                margin: 0,
                fontFamily: "Outfit",
                textAlign: isSmallScreen ? "left" : "Center",
                marginBottom: "5%",
              }}
            >
              Revenue prediction
            </h1>

            <Box
              style={{
                display: "flex",
                gap: "24px",
                alignItems: "center",
                marginLeft: isSmallScreen ? "0" : "9%",
                width: "100%",
                textAlign: isSmallScreen ? "left" : "Center",

                flexWrap: isXs ? "wrap" : "nowrap",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "13px",
                  color: "#9048FB",
                }}
              >
                <Box
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#8b5cf6",
                  }}
                ></Box>
                <span
                  style={{
                    fontFamily: "Outfit",
                    fontWeight: "500",
                    fontSize: "13px",
                    color: "#A3AED0",
                  }}
                >
                  Current Year 2024
                </span>
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "13px",
                  color: "#6b7280",
                }}
              >
                <Box
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#4BC7E1",
                  }}
                ></Box>
                <span
                  style={{
                    fontFamily: "Outfit",
                    fontWeight: "500",
                    fontSize: "13px",
                    color: "#A3AED0",
                  }}
                >
                  projections
                </span>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: "16px",
              backgroundColor: "#FFFFFF", // white background
              padding: isSmallScreen
                ? isXs
                  ? "16px 20px"
                  : "18px 22px"
                : "20px 24px",
              borderRadius: "16px",
              minWidth: isSmallScreen ? "auto" : "280px",
              mt: {
                xs: 0,
                sm: 0,
                md: 0,
                lg: 0,
                xl: "-3%", // only for xl
              },
              boxShadow: "4px 4px 12px rgba(0, 0, 0, 0.1)", // shadow left, right, bottom
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Box
                style={{
                  fontSize: "15px",
                  color: "#64748b",
                  fontWeight: "500",
                  marginBottom: "8px",
                  textAlign: "left",
                }}
              >
                Growth prediction
              </Box>
              <Box
                style={{
                  fontSize: isSmallScreen ? (isXs ? "28px" : "32px") : "36px",
                  fontWeight: "800",
                  color: "#1e293b",
                  marginBottom: "8px",
                  lineHeight: "1",
                  textAlign: "left",
                }}
              >
                $12310
              </Box>
              <Box
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  textAlign: isSmallScreen ? "left" : "center",
                }}
              >
                <span style={{ color: "#10b981", fontWeight: "600" }}>
                  +23%
                </span>{" "}
                <span style={{ color: "#94a3b8" }}>
                  increased over the past month
                </span>
              </Box>
            </Box>
            <Box
              style={{
                width: isSmallScreen ? (isXs ? "80px" : "90px") : "100px",
                height: isSmallScreen ? (isXs ? "48px" : "54px") : "60px",
                marginTop: "4px",
              }}
            >
              <svg
                viewBox="0 0 100 60"
                style={{ width: "100%", height: "100%" }}
              >
                <path
                  d="M5,45 L15,35 L25,20 L35,40 L45,15 L55,8 L65,25 L75,12 L85,30 L95,20"
                  fill="none"
                  stroke="#8b5cf6"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>
          </Box>
        </Box>

        {/* Chart */}
        <Box
          sx={{
            width: "100%",
            height: isSmallScreen
              ? isXs
                ? "280px"
                : isSm
                ? "300px"
                : "310px"
              : "320px",
            position: "relative",
            marginTop: "12px",
            marginLeft: {
              xs: "-18%",
              sm: 0,
              md: 0,
              lg: "-3.5%", // Only applies from large screens and up
            },
          }}
        >
          <ResponsiveContainer width="105%" height="100%">
            <LineChart
              data={data}
              margin={{
                top: 10,
                right: isSmallScreen ? (isXs ? 20 : 25) : 30,
                left: 20,
                bottom: 10,
              }}
            >
              <CartesianGrid
                strokeDasharray="0"
                stroke="#f1f5f9"
                strokeWidth={1}
                horizontal={true}
                vertical={false}
              />
              <XAxis
                dataKey="month"
                axisLine={false}
                tickLine={false}
                tick={{
                  fill: "#9ca3af",
                  fontSize: isSmallScreen ? (isXs ? 10 : 11) : 11,
                  fontWeight: 400,
                }}
                dy={16}
              />
              <YAxis
                domain={[0, 80]}
                ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80]}
                axisLine={false}
                tickLine={false}
                tick={{
                  fill: "#cbd5e1",
                  fontSize: isSmallScreen ? (isXs ? 10 : 11) : 11,
                  fontWeight: 400,
                }}
                tickFormatter={formatYAxisTick}
                dx={16}
              />
              <ReferenceLine
                x="May.5"
                stroke="#e2e8f0"
                strokeDasharray="3 3"
                strokeWidth={1}
              />
              <Line
                type="monotone"
                dataKey="actual"
                stroke="#8b5cf6"
                strokeWidth={2.5}
                dot={false}
                connectNulls={false}
                strokeLinecap="round"
              />
              <Line
                type="monotone"
                dataKey="predicted"
                stroke="#60a5fa"
                strokeWidth={2.5}
                strokeDasharray="6 6"
                dot={false}
                connectNulls={true}
                strokeLinecap="round"
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default RevenuePrediction;
